enum ValidationState {
  VALID,
  VALIDATING,
  FAILED,
  UNSET
}

export { ValidationState }
